import React  from "react";
import { Form, Col } from "react-bootstrap";
import { ApplicantContainer} from "../unstated/applicant";
import { Fragment } from "react";

export default function Sports() {
    
    let app = ApplicantContainer.useContainer();

    let inputSports = app.inStdValues.frSports;

      const addSports = index => {    

        const values = [...inputSports];
        values.splice(index+1, 0, { SportLevel: '', SportType: '', SportPeriod: '', SportRemark: '' });
       
        app.onChangeInStdValues({...app.inStdValues, frSports:values});
      }

      const delSports = index => {    

        if(inputSports.length === 1) return 0;

        const values = [...inputSports];    
        values.splice(index, 1);

        if(values.length === 1) values[0].highest = true;       

      

        app.onChangeInStdValues({...app.inStdValues, frSports:values});
      }

      const handleInputChange = (inputname, index, event) => {        
        const values = [...inputSports];  
        
        values[index].[inputname] = event.target.value;    
       
        app.onChangeInStdValues({...app.inStdValues, frSports:values});
      };

    return (
app.showSports ?
  <>

    <Form.Row className="d-none d-lg-flex">

      <Col xs={12} md={5} lg={2} className='table-header'>
        <Form.Group as={Col} controlId="frSportLevel">
        <Form.Label>Level</Form.Label>
        </Form.Group>
      </Col>
      <Col xs={12} md={5} lg={4} className='table-header'>
        <Form.Group as={Col} controlId="frTypeSports">
        <Form.Label>Type of sports</Form.Label>
        </Form.Group>
      </Col>
      <Col xs={12} md={5} lg={2} className='table-header'>
        <Form.Group as={Col} controlId="frSportPeriod">
        <Form.Label>Involvement Period</Form.Label>
        </Form.Group>
      </Col>
      <Col xs={12} md={5} lg={2} className='table-header'>
        <Form.Group as={Col} controlId="frSportRemarks">
        <Form.Label>Remarks</Form.Label>
        </Form.Group>
      </Col>        
      <Col xs={12} md={2} lg={2} className='table-header'>          
        <Form.Group as={Col} controlId="frControls" className="segbutton d-flex justify-content-center">
          <Form.Label>action</Form.Label>
      </Form.Group>
      </Col>        
    </Form.Row> 


    {inputSports.map((inputField, index) => (      
      <Fragment key={`${inputField}~${index}`}>
        <Form.Row >
          <Col xs={12} md={5} lg={2}>
            <Form.Group as={Col} controlId="frSportLevel">
            <Form.Label className="d-flex d-lg-none">Level</Form.Label>
            <Form.Control as="select"   
              required
              value={inputField.SportLevel}              
              onChange={(event) => handleInputChange('SportLevel', index, event)} >
              <option key="" value=""></option>
              <option key='National' value='National'>National</option>
              <option key='State' value='State'>State</option>            
            </Form.Control>
              
              
            </Form.Group>
          </Col>
          <Col xs={12} md={5} lg={4}>
            <Form.Group as={Col} controlId="frTypeSports">
              <Form.Label className="d-flex d-lg-none">Type of sports</Form.Label>
              <Form.Control type="text" required value={inputField.SportType} onChange={event => handleInputChange('SportType', index, event)} />
            </Form.Group>
          </Col>
          <Col xs={12} md={5} lg={2}>
            <Form.Group as={Col} controlId="frSportPeriod">
              <Form.Label className="d-flex d-lg-none">Involvement Period</Form.Label>
              <Form.Control type="text" required value={inputField.SportPeriod} onChange={event => handleInputChange('SportPeriod', index, event)} />
            </Form.Group>
          </Col>
          <Col xs={12} md={5} lg={2}>
            <Form.Group as={Col} controlId="frSportRemarks">
              <Form.Label className="d-flex d-lg-none">Remarks</Form.Label>
              <Form.Control type="text" required value={inputField.SportRemark} onChange={event => handleInputChange('SportRemark', index, event)} />
            </Form.Group>
          </Col>        
          <Col xs={12} md={2}  lg={2}>          
            <Form.Group as={Col} controlId="frControls" className="segbutton d-flex justify-content-center">
              <Form.Label>&nbsp;</Form.Label>
              <Form.Control type="button" className="add btn btn-outline-primary" value="+" onClick={() => addSports(index)} />&nbsp;
              <Form.Control type="button" className="del btn btn-outline-danger" value="-" onClick={() => delSports(index)} />
          </Form.Group>
          </Col>        
        </Form.Row>
        <hr className="d-flex d-lg-none" /> 
      </Fragment>
    ))}
  </>
  :  <></>
    );
}